// 借入申込内容変更
import React from 'react';
import TopArea from '../../molecules/TopArea';
import MypageReturn from '../../molecules/MypageReturn';
import HeadingM from '../../molecules/HeadingM';
import LoadingModal from '../../molecules/LoadingModal';

interface Props {
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  display_status: boolean;
  is_loading: boolean;
}

const ExaminationChange: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  reception_cd,
  display_status,
  is_loading,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        guide_text={guide_text}
        display_reception_cd={display_reception_cd}
        display_status={display_status}
      />
      <HeadingM label="申込内容の変更待ち" />
      <p className="mt-3">
        ただいまお申込人の方が申込内容を変更しています。
        <br />
        恐れ入りますが変更された申込内容が登録されるまでお待ち下さい。改めて通知メールをお送りいたします。
        <br />
        ウィンドウまたはタブを閉じて下さい。
      </p>
      <MypageReturn is_staff={false} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ExaminationChange;
